import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface PageBodyProps {
  children: ReactNode;
  className?: string;
  contentClassName?: string;
  maxWidthClassName?: string;
}

export function PageBody({
  children,
  className,
  contentClassName,
  maxWidthClassName = 'max-w-6xl',
}: PageBodyProps): React.ReactElement {
  return (
    <div
      className={cn(
        'relative flex-1 overflow-auto px-4 py-5 md:px-6 md:py-6',
        // --page-glow (src/index.css) is color-mix(--primary 9%), replacing a
        // hardcoded rgba(96,165,250,0.09). Same rendered colour today, but it now
        // follows the accent token instead of pinning Tailwind's blue-400.
        'bg-[radial-gradient(circle_at_top,_var(--page-glow),_transparent_38%)]',
        className
      )}
    >
      <div className="pointer-events-none absolute inset-x-0 top-0 h-28 bg-gradient-to-b from-primary/6 via-accent/4 to-transparent" />
      <div className={cn('relative mx-auto w-full', maxWidthClassName, contentClassName)}>
        {children}
      </div>
    </div>
  );
}
